import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import appRoutes from './routes';

import RouteWrapper from "./components/system/RouteWrapper";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from "./layouts/Loading";
import { CartProvider } from './context/CartContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
    return (
        <CartProvider>

        <Router>
            <ToastContainer rtl />
            <Suspense fallback={<Loading />}>
                <Routes>
                    {appRoutes.map(route => (
                        <Route
                            key={route.pageId}
                            path={route.path}
                            element={<RouteWrapper title={route.title}>{route.component}</RouteWrapper>}
                        />
                    ))}
                </Routes>
            </Suspense>
        </Router>
        </CartProvider>
    );
}

export default App;
